import React from "react";
import { UnidadesSaudePage } from "./unidadesSaude.page";
import { UnidadesSaudeProvider } from "./context/unidades-saude-context";

export function UnidadesSaudeFactory() {
    return (
        <UnidadesSaudeProvider>
            <UnidadesSaudePage></UnidadesSaudePage>
        </UnidadesSaudeProvider>
    );
}
